<template>
  <div class="contextStyle">
    <row
      class="index_font_and_img"
      type="flex"
      justify="space-between"
      v-if="isleftFont"
    >
      <i-col span="10" class="index_font">
        <div class="index_font_left">
          <div class="context_img">
            <div class="index_font_title" v-html="title"></div>
            <div v-html="subTitle" class="index_font_context"></div>
          </div>
        </div>
      </i-col>
      <i-col span="13" class="iColStyle">
        <img :src="getImgUrl(src)" class=" index_img" />
      </i-col>
    </row>
    <row class="index_font_and_img" type="flex" justify="space-between" v-else>
      <i-col span="13" class="iColStyle">
        <img :src="getImgUrl(src)" class="index_img" />
      </i-col>
      <i-col span="10" class="index_font">
        <div class="index_font_right">
          <div class="context_img">
            <div class="index_font_title" v-html="title"></div>
            <div v-html="subTitle" class="index_font_context"></div>
          </div>
        </div>
      </i-col>
    </row>
  </div>
</template>
<script>
export default {
  props: {
    isleftFont: {
      type: Boolean,
      default: true
    },
    src: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    subTitle: {
      type: String,
      default: ""
    }
  },
  methods: {
    getImgUrl(icon) {
      return require("../../../../public/static/image" + icon);
    }
  }
};
</script>
<style lang="less" scoped>
//所有分辨率下均采用
.iColStyle {
  display: flex;
  justify-content: center;
  align-items: center;
}
//屏幕大于992以上的框架自动做适配
@media screen and (min-width: 1400px) {
  .contextStyle {
    padding: 30px 0;
    padding-left: 18vw;
    padding-right: 18vw;
  }
}
@media screen and (max-width: 1400px) {
  .contextStyle {
    padding: 20px 0;
    padding-left: 10vw;
    padding-right: 10vw;
  }
}
@media screen and (max-width: 1000px) {
  .contextStyle {
    padding: 10px 0;
    padding-left: 3vw;
    padding-right: 3vw;
  }
}
@media screen and (max-width: 960px) {
  .contextStyle {
    padding: 8px 0;
    padding-left: 4px;
    padding-right: 4px;
  }
}
@media screen and (max-width: 576px) {
  .index_font_left {
    display: none;
  }
}
.index_font_and_img {
  width: 100%;
}
.index_font {
  align-items: center;
  display: flex;
  justify-content: center;
  .index_font_left {
    width: 100%;
    justify-content: center;
    display: flex;
  }
  .index_font_right {
    width: 100%;
    align-items: center;
    display: flex;
    justify-content: center;
  }
}
.index_font {
  .index_font_left {
    .context_img {
      width: 75%;
      text-align: right;
      .index_font_title {
        font-size: 32px;
        text-align: right;
        font-weight: bold;
        padding: 3px 0;
        padding-right: 12px;
      }
      .index_font_context {
        font-size: 20px;
        text-align: left;
      }
    }
  }
  .index_font_right {
    .context_img {
      width: 75%;
      text-align: right;
      .index_font_title {
        font-size: 32px;
        text-align: left;
        font-weight: bold;
        padding: 3px 0;
      }
      .index_font_context {
        font-size: 20px;
        text-align: left;
      }
    }
  }
}
// @media screen and (min-width: 960px) {
//   .index_font {
//     background: violet;
//     .index_font_left {
//       .context_img {
//         width: 75%;
//         text-align: right;
//         .index_font_title {
//           font-size: 50px;
//           text-align: right;
//           font-weight: bold;
//           padding: 10px 0;
//         }
//         .index_font_context {
//           font-size: 20px;
//           text-align: left;
//         }
//       }
//     }
//     .index_font_right {
//       .context_img {
//         width: 75%;
//         text-align: right;
//         .index_font_title {
//           font-size: 50px;
//           text-align: left;
//           font-weight: bold;
//           padding: 10px 0;
//         }
//         .index_font_context {
//           font-size: 20px;
//           text-align: left;
//         }
//       }
//     }
//   }
// }
// @media screen and (max-width: 960px) {
//   .index_font {
//     background: yellowgreen;
//     .index_font_left {
//       .context_img {
//         max-width: 90%;
//         .index_font_title {
//           font-size: 40px;
//           text-align: right;
//           font-weight: bolder;
//           padding: 10px 0;
//         }
//         .index_font_context {
//           font-size: 18px;
//           text-align: left;
//           min-width: 150px;
//         }
//       }
//     }
//     .index_font_right {
//       .context_img {
//         max-width: 90%;
//         text-align: right;
//         .index_font_title {
//           font-size: 40px;
//           text-align: left;
//           font-weight: bolder;
//           padding: 10px 0;
//         }
//         .index_font_context {
//           font-size: 18px;
//           text-align: left;
//         }
//       }
//     }
//   }
// }

// @media screen and (max-width: 730px) {
//   .index_font {
//     background: red;
//     .index_font_left {
//       .context_img {
//         max-width: 100%;
//         .index_font_title {
//           font-size: 30px;
//           text-align: right;
//           font-weight: bolder;
//         }
//         .index_font_context {
//           font-size: 16px;
//           text-align: left;
//           min-width: 150px;
//         }
//       }
//     }
//     .index_font_right {
//       .context_img {
//         max-width: 100%;
//         text-align: right;
//         .index_font_title {
//           font-size: 30px;
//           text-align: left;
//           font-weight: bolder;
//         }
//         .index_font_context {
//           font-size: 16px;
//           text-align: left;
//         }
//       }
//     }
//   }
// }

// @media screen and (max-width: 576px) {
//   .index_font {
//     background: green;
//     .index_font_left {
//       .context_img {
//         max-width: 100%;
//         .index_font_title {
//           font-size: 18px;
//           text-align: right;
//           font-weight: bolder;
//           padding: 10px 0;
//         }
//         .index_font_context {
//           font-size: 12px;
//           text-align: left;
//         }
//       }
//     }
//     .index_font_right {
//       .context_img {
//         max-width: 100%;
//         text-align: right;
//         .index_font_title {
//           font-size: 18px;
//           text-align: left;
//           font-weight: bolder;
//           padding: 10px 0;
//         }
//         .index_font_context {
//           font-size: 12px;
//           text-align: left;
//         }
//       }
//     }
//   }
// }
// @media screen and (max-width: 475px) {
//   .index_font {
//     background: red;
//     .index_font_left {
//       .context_img {
//         max-width: 100%;
//         .index_font_title {
//           font-size: 14px;
//           text-align: right;
//           font-weight: bolder;
//           padding: 10px 0;
//         }
//         .index_font_context {
//           font-size: 6px;
//           text-align: left;
//         }
//       }
//     }
//     .index_font_right {
//       .context_img {
//         max-width: 100%;
//         text-align: right;
//         .index_font_title {
//           font-size: 14px;
//           text-align: left;
//           font-weight: bolder;
//           padding: 10px 0;
//         }
//         .index_font_context {
//           font-size: 6px;
//           text-align: left;
//         }
//       }
//     }
//   }
// }

.index_img {
  width: 90%;
}
.index_img_context {
  width: 80%;
}
.index_img_context_right {
  width: 80%;
  float: right;
}
</style>
